var _g, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRevision(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.84,
    height: 21.59,
    viewBox: "0 0 18.84 21.59",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ICONOS_FLUJO",
    "data-name": "ICONOS FLUJO"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Revisi\\xF3n"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_11",
    "data-name": 11
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M12.57,15.35a1.37,1.37,0,1,1,1.37,1.37A1.37,1.37,0,0,1,12.57,15.35Zm.47,0a.9.9,0,1,0,.9-.9A.9.9,0,0,0,13,15.35Z",
    transform: "translate(-1.8 -0.57)",
    fill: "{props.color}",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.6,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.85,16.3a2,2,0,0,1,0-1.9,3.76,3.76,0,0,1,3.09-1.91A3.73,3.73,0,0,1,17,14.4a1.9,1.9,0,0,1,0,1.9,3.72,3.72,0,0,1-3.08,1.9A3.73,3.73,0,0,1,10.85,16.3Zm.4-1.65a1.49,1.49,0,0,0,0,1.39,3.3,3.3,0,0,0,2.69,1.69A3.27,3.27,0,0,0,16.62,16a1.43,1.43,0,0,0,0-1.39A3.26,3.26,0,0,0,13.94,13,3.29,3.29,0,0,0,11.25,14.65Z",
    transform: "translate(-1.8 -0.57)",
    fill: "{props.color}",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.6,
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "user-responsible"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M8.05,15.09a5.85,5.85,0,1,1,5.85,5.84A5.86,5.86,0,0,1,8.05,15.09Zm.86,0a5,5,0,1,0,5-5A5,5,0,0,0,8.91,15.09Z",
    transform: "translate(-1.8 -0.57)",
    fill: "{props.color}",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.5,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.65,21.19,18.45,20a.43.43,0,0,1,0-.61.42.42,0,0,1,.6,0l1.21,1.21a.42.42,0,0,1,0,.6.46.46,0,0,1-.35.17C19.74,21.36,19.74,21.28,19.65,21.19Z",
    transform: "translate(-1.8 -0.57)",
    fill: "{props.color}",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  })))), /*#__PURE__*/React.createElement("g", {
    id: "_5",
    "data-name": 5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.5,5.07h2a.7.7,0,1,1,0,1.4H15.8a.71.71,0,0,1-.7-.8V2.37a.63.63,0,0,1,.7-.7.68.68,0,0,1,.7.7v2.7Z",
    transform: "translate(-1.8 -0.57)",
    fill: "{props.color}",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.44.58a7,7,0,0,1,1,0A7.05,7.05,0,0,1,18.11,2c1.78,1.47,2,3.89,2.1,5.78a13.18,13.18,0,0,1-.06,2.53.7.7,0,0,1-.65.79.69.69,0,0,1-.6-.8v-2c0-4.6-1.4-6.2-5.3-6.2H8.4c-3.9,0-5.3,1.6-5.3,6.2v6c0,4.6,1.4,6.3,5.3,6.3h1.7c.3,0,.6.3.6.8s-.3.8-.6.8H8.4c-4.6,0-6.6-2.3-6.6-7.8v-6C1.8,3,3.8.67,8.4.67,8.69.67,10.27.62,13.44.58Z",
    transform: "translate(-1.8 -0.57)",
    fill: "{props.color}"
  })), /*#__PURE__*/React.createElement("g", {
    id: "lineas"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.89,9H6.11S6,9,6,9a1.18,1.18,0,0,1-.1-.39A1.12,1.12,0,0,1,6,8.21c0-.05.07,0,.1,0H9.78c.07,0,.12.15.12.38S9.85,9,9.78,9s-.06,0-.09,0Z",
    transform: "translate(-1.8 -0.57)",
    fill: "{props.color}",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.92,6.39H6.37c-.31,0-.49-.15-.47-.41s.22-.38.47-.38c1.7,0,3.39,0,5.09,0,.32,0,.48.15.46.41s-.21.39-.46.38Z",
    transform: "translate(-1.8 -0.57)",
    fill: "{props.color}",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.8
  }))))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.46,22",
    transform: "translate(-1.8 -0.57)",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.88,17.54",
    transform: "translate(-1.8 -0.57)",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 1.1,
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRevision);
export default __webpack_public_path__ + "static/media/revision.68b274db76c83b7e876970814e5391e7.svg";
export { ForwardRef as ReactComponent };